import { render, staticRenderFns } from "./UserBillingAddress.vue?vue&type=template&id=2968198c"
import script from "./UserBillingAddress.vue?vue&type=script&lang=js"
export * from "./UserBillingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "ffc2b7d6"
  
)

export default component.exports